export default __webpack_public_path__ + "static/media/peace-of-mind.9c5a1091.png";